import type { XlsxWorkerArgs, XlsxWorkbook } from '~/utils/exportXlsx'
import ExportXlsxWorker from '~/workers/exportXlsx.worker?worker'

/* Runs XLSX generation off the main thread so large exports don't freeze the
   UI. Replaces the nuxt-workers module (broken on Nuxt 4 — WFL-6632). */
export const exportToXlsxInWorker = (
  args: XlsxWorkerArgs,
): Promise<XlsxWorkbook> => {
  // Safari versions below 17.4 lack Promise.withResolvers.
  return new Promise((resolve, reject) => {
    const worker = new ExportXlsxWorker()
    worker.onmessage = (e: MessageEvent<XlsxWorkbook>) => {
      worker.terminate()
      resolve(e.data)
    }
    worker.onerror = (e) => {
      worker.terminate()
      reject(e)
    }
    worker.postMessage({ ...args, mapping: { ...args.mapping } })
  })
}
